import { render, staticRenderFns } from "./purchaseTable.vue?vue&type=template&id=46680ca9&scoped=true"
import script from "./purchaseTable.vue?vue&type=script&lang=js"
export * from "./purchaseTable.vue?vue&type=script&lang=js"
import style0 from "./purchaseTable.vue?vue&type=style&index=0&id=46680ca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46680ca9",
  null
  
)

export default component.exports